import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BookedSessionByBookingKey } from 'app/shared/models/class/booking-session/booking-session';

@Component({
  selector: 'app-table-booking-progress',
  templateUrl: './table-booking-progress.component.html',
  styleUrls: ['./table-booking-progress.component.scss']
})
export class TableBookingProgressComponent implements OnInit {

  @Input() set sesisonBookSelected(value: BookedSessionByBookingKey[]) {
    this.dataSource.data = value;
    this.length = value?.length;
  }

  displayedColumns: string[] = ['offerName', 'date', 'status', 'price'];
  dataSource = new MatTableDataSource<BookedSessionByBookingKey>();

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  constructor() { }

  ngOnInit(): void {
    this.initComponent();
  }

  private initTable(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  private initComponent(): void {
    this.initTable();
  }
}
